module.exports = __webpack_public_path__ + "img/activeendpic.1de055f0.png";